var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccessLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user--access-locked_svg__clip0_61530_7327)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 6V3.75c0-1.654-1.346-3-3-3s-3 1.346-3 3V6c-.827 0-1.5.673-1.5 1.5V12c0 .827.673 1.5 1.5 1.5h6c.827 0 1.5-.673 1.5-1.5V7.5c0-.827-.673-1.5-1.5-1.5zm-4.5-2.25c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5V6h-3V3.75zM15 12V7.5h6V12h-6zM12 22.5h-1.5v-3.75a2.252 2.252 0 00-2.25-2.25h-3A2.252 2.252 0 003 18.75v3.75H1.5v-3.75A3.754 3.754 0 015.25 15h3A3.754 3.754 0 0112 18.75v3.75zM6.75 7.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0-1.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user--access-locked_svg__clip0_61530_7327"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserAccessLocked;